// Account
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';

// Router
export const LOCATION_CHANGE_TYPE = '@@router/LOCATION_CHANGE';
